import { useState } from "react";
import styles from "./styles.module.css";
import Modal from "react-responsive-modal";
import Table from "../../../components/TableConstructor";
import { MetaCalendario } from "../../../model/PlanoDeTrabalho/PlanoAplicacao";

import RowCalendario from "../../../components/TableConstructor/Row/RowCalendario";
import ModalMetaCalendario from "../../../components/ModalForms/ModalMetaCalendario";
import { MetaFisica } from "../../../model/PlanoDeTrabalho/CronogramaExecucao";

type Props = {
  passarPagina: Function;
  voltarPagina: Function;
  listaAplicacoesOSC: MetaCalendario[];
  setAplicacoesOSC: React.Dispatch<React.SetStateAction<MetaCalendario[]>>;
  listaAplicacoesOrgao: MetaCalendario[];
  setAplicacoesOrgao: React.Dispatch<React.SetStateAction<MetaCalendario[]>>;
  listaMetas: MetaFisica[];
  title: JSX.Element;
};

function CronogramaCalendario({
  passarPagina,
  voltarPagina,
  listaAplicacoesOrgao,
  setAplicacoesOrgao,
  listaAplicacoesOSC,
  setAplicacoesOSC,
  listaMetas,
  title,
}: Props) {
  const [showAddOrg, setAddOrg] = useState(false);
  const [showAddOSC, setAddOSC] = useState(false);
  const [showEditOrg, setEditOrg] = useState(-1);
  const [showEditOSC, setEditOSC] = useState(-1);

  return (
    <div>
      <h2 className={styles.titulo}>{title}</h2>
      <hr className={styles.separador} />
      <h3 className={styles.subTitulo}>Orgão/Entidade:</h3>
      <Table
        listTitle={[
          "Etapa/Fase",
          "Ano",
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez",
          "Total",
          "",
        ]}
        styleList={[1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]}
      >
        {listaAplicacoesOrgao.map((metaObj, index) => (
          <RowCalendario metaObj={metaObj} key={index}>
            <>
              <button
                className={styles.btn}
                onClick={(e) => {
                  e.preventDefault();
                  setEditOrg(index);
                }}
              >
                Editar
              </button>
              <Modal
                open={showEditOrg === index}
                onClose={() => setEditOrg(-1)}
                center
                classNames={{
                  modal: "customModal",
                }}
              >
                <ModalMetaCalendario
                  closeModal={() => setEditOrg(-1)}
                  list={listaAplicacoesOrgao}
                  setList={setAplicacoesOrgao}
                  index={index}
                  listaMetas={listaMetas}
                  refMeta={metaObj}
                />
              </Modal>
            </>
          </RowCalendario>
        ))}
      </Table>
      <div className={styles.addDiv}>
        <button
          className={styles.addBtn}
          onClick={(e) => {
            e.preventDefault();
            setAddOrg(true);
          }}
        >
          + Adicionar Meta
        </button>
      </div>
      <Modal
        open={showAddOrg}
        onClose={() => setAddOrg(false)}
        center
        classNames={{
          modal: "customModal",
        }}
      >
        <ModalMetaCalendario
          closeModal={() => setAddOrg(false)}
          list={listaAplicacoesOrgao}
          listaMetas={listaMetas}
          setList={setAplicacoesOrgao}
        />
      </Modal>

      <hr className={styles.separador} />
      <h3 className={styles.subTitulo}>Organização da Sociedade Civil:</h3>
      <Table
        listTitle={[
          "Etapa/Fase",
          "Ano",
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez",
          "Total",
          "",
        ]}
        styleList={[1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]}
      >
        {listaAplicacoesOSC.map((metaObj, index) => (
          <RowCalendario metaObj={metaObj} key={index}>
            <>
              <button
                className={styles.btn}
                onClick={(e) => {
                  e.preventDefault();
                  setEditOSC(index);
                }}
              >
                Editar
              </button>
              <Modal
                open={showEditOSC === index}
                onClose={() => setEditOSC(-1)}
                center
                classNames={{
                  modal: "customModal",
                }}
              >
                <ModalMetaCalendario
                  closeModal={() => setEditOSC(-1)}
                  list={listaAplicacoesOSC}
                  setList={setAplicacoesOSC}
                  listaMetas={listaMetas}
                  index={index}
                  refMeta={metaObj}
                />
              </Modal>
            </>
          </RowCalendario>
        ))}
      </Table>
      <div className={styles.addDiv}>
        <button
          className={styles.addBtn}
          onClick={(e) => {
            e.preventDefault();
            setAddOSC(true);
          }}
        >
          + Adicionar Meta
        </button>
      </div>
      <Modal
        open={showAddOSC}
        onClose={() => setAddOSC(false)}
        center
        classNames={{
          modal: "customModal",
        }}
      >
        <ModalMetaCalendario
          closeModal={() => setAddOSC(false)}
          list={listaAplicacoesOSC}
          listaMetas={listaMetas}
          setList={setAplicacoesOSC}
        />
      </Modal>

      <div className="flex justify-between">
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            voltarPagina();
          }}
        >
          ❮❮ Anterior
        </button>
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            passarPagina();
          }}
        >
          Proximo ❯❯
        </button>
      </div>
    </div>
  );
}

export default CronogramaCalendario;
